import { makeStyles } from '@material-ui/core';

export default makeStyles(() => ({
  gridItem: {
    marginTop: '1rem',
    position: 'relative',
    padding: 0,
  },
  description: {
    paddingRight: '20rem',
  },
}));
